<template>
  <div class="hope" >
    <div class="hope-title">
      <span>企业愿景</span>
    </div>
    <div class="hope-content">
      <div class="hope-left">
        <img :src="'http://'+ HopePhoto" alt="">
        <div class="img-back"></div>
      </div>
      <div class="hope-right">
        <pre>{{HopeDes}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CompanyHope",
    props:{

    },
    data(){
      return{
        Data:{},
        HopePhoto:{},
        HopeDes:{},
      }
    },
    created() {
      this.GetData()
    },
    methods:{
      GetData(){
        this.$axios.get('/api/companyIntro/getById?id=1').then(res=>{

          this.Data=res.data.data
          // this.ItemDes=this.Data.description;
          // this.ItemImg=this.Data.introPhotoUrl;
          // // this.CulturePhoto=this.Data.culturePhotoUrl;
          this.HopePhoto=this.Data.visionPhotoUrl;
          this.HopeDes=this.Data.visionDescription;
          // this.MeanUrl=this.Data.ideaPhotoUrl;
          // this.MeanDes=this.Data.manageIdeaDescription;
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .hope{
    width: 74.5vw;
    margin: 0 auto;
    .hope-title{
      padding: 20px 30px;
      text-align: left;
      margin: 30px 0;
      span{

    height: 32px;
    font-size: 32px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 48px;
    letter-spacing: 1px;
  }
      text-align: center;
      }
    .hope-content{
      display: flex;
      .hope-left{
          width: 33.2vw;
          margin-top: 10px;

          position: relative;
          z-index: 5;
          img{
            width: 90%;
            height: 36.1vh;
          }
          .img-back{
            width: 86%;
            height: 36.1vh;
            z-index: -60;
            opacity: 0.1;
            border: 11px solid #358ED7;
            position: absolute;
            top: 30px;
            left: 40px;
          }
        }
      .hope-right{
        margin-top: 20px;
        margin-left: 120px;
        pre{
          font-size: 21px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
        }
      }
    }
  }

</style>